<template>
  <div class="h-full">
    <LinkTabBar :tabs="tabs" />
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import LinkTabBar from '@/common/components/LinkTabBar';

export default {
  name: 'Profiles',
  components: {
    LinkTabBar,
  },
  data() {
    return {
      tabs: [
        { label: 'Daftar Kabupaten/Kota', link: '/profil-jawa-barat/tentang/kabupaten-kota', dataCy: 'document__tab-menu' },
        { label: 'Daftar Perangkat Daerah', link: '/profil-jawa-barat/tentang/perangkat-daerah', dataCy: 'about__tab-menu' },
      ],
    };
  },
};
</script>
